import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CollageDesignerSuccess from './CollageDesignerSuccess';
import withModal from '../../../modal/withModal';
import DismissButton from '../../../DismissButton';

export const COLLAGE_DESIGNER_SUCCESS_MODAL = 'modal/COLLAGE_DESIGNER_SUCCESS';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string,
  }),
  actionProps: PropTypes.shape({
    accountCard: PropTypes.shape({
      id: PropTypes.string,
    }),
    onGoBack: PropTypes.func,
    onAddToCart: PropTypes.func,
    addToCartLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }),
  onGoBack: PropTypes.func.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

const CollageDesignerSuccessModal = ({
  title = 'Share your design',
  accountCard,
  onAddToCart,
  onGoBack,
  onClose,
  onRequestClose,
  actionProps = {},
  ...props
}) => {
  const {
    accountCard: actionPropsAccountCard,
    onGoBack: actionPropsOnGoBack,
    onAddToCart: actionPropsOnAddToCart,
    addToCartLabel: actionPropsAddToCartLabel,
  } = actionProps;

  return (
    <Fragment>
      <div className="collage-designer-success-modal-header">
        <span className="collage-designer-success-modal-title">{title}</span>
        <DismissButton onClick={onClose ?? onRequestClose} />
      </div>
      <div className="collage-designer-success-modal-container">
        <CollageDesignerSuccess
          accountCard={actionPropsAccountCard ?? accountCard}
          onGoBack={actionPropsOnGoBack ?? onGoBack}
          onAddToCart={actionPropsOnAddToCart ?? onAddToCart}
          addToCartLabel={actionPropsAddToCartLabel}
          {...props}
        />
      </div>
    </Fragment>
  );
};

CollageDesignerSuccessModal.propTypes = propTypes;

export default withModal(CollageDesignerSuccessModal, {
  name: COLLAGE_DESIGNER_SUCCESS_MODAL,
  size: 'sm',
  type: 'full',
  dismissible: false,
  hideHeader: true,
  className: 'collage-designer-success-modal modal-floating-panel',
});
